export const SET_HELP_MODE_STEP = 'SET_HELP_MODE_STEP';
